import React, { useEffect } from 'react';
import logo from './logo.svg';
import './App.css';
import RootRoutes from './routing/routes';
import { store } from './redux/store';
import { Provider } from 'react-redux';
import { TokenContext } from './service/context/tokencontent';
import ToastProvider from './components/Toast/ToastContainer';
import { Toaster } from 'react-hot-toast';
import { GoogleMapsProvider } from './contexts/GoogleMapsContext';

function App() {
  let token = localStorage.getItem("motosop")
  const [tokenState, setTokenState] = React.useState(token)

  useEffect(() => {
    if (token) {
      setTokenState(token)
    }
  }
    , [token])

  return (
    <>
      <Provider store={store}>
        <GoogleMapsProvider>
          <ToastProvider>
            <TokenContext.Provider value={{ token: tokenState, setToken: setTokenState }}>
              <RootRoutes />
            </TokenContext.Provider>
          </ToastProvider>
          <Toaster
            position="top-center"
          />
        </GoogleMapsProvider>
      </Provider>
    </>
  );
}

export default App;
